import UserDTO from './user';
import { Timestamps } from './shared';
// eslint-disable-next-line import/no-cycle
import { OrderDTO } from './order';

export enum PaymentRecipient {
  AVANTTI = 'avantti',
  BUSINESS = 'business',
  SPLIT = 'split',
}
export enum PaymentStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  REIMBURSED = 'reimbursed',
  REJECTED = 'rejected',
}

export enum PaymentType {
  MANUAL = 'manual',
  ONLINE = 'online',
}

export enum PaymentProvider {
  MERCADOPAGO = 'MERCADOPAGO',
  UALA = 'UALA',
  AVANTTI = 'AVANTTI',
  PAYWAY = 'PAYWAY',
  NAVE = 'NAVE',
  NAVE_LINK = 'NAVE_LINK',
  ZILO = 'ZILO',
}

export enum PaymentMethod {
  CASH = 'cash',
  SELLER = 'seller',
  WIRE_TRANSFER = 'wire_transfer',
  MP_ONLINE_CHECKOUT = 'mp_online_checkout',
  MP_POINT = 'mp_point',
  UALA_CHECKOUT_ONLINE = 'uala_checkout_online',
  PAYWAY_CHECKOUT_ONLINE = 'payway_checkout_online',
  NAVE_CHECKOUT_ONLINE = 'nave_checkout_online',
  NAVE_LINK_CHECKOUT_ONLINE = 'nave_link_checkout_online',
  OTHER = 'other',
}

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.CASH]: 'Efectivo',
  [PaymentMethod.WIRE_TRANSFER]: 'Transferencia',
  [PaymentMethod.MP_POINT]: 'Mercado Pago Point',
  [PaymentMethod.SELLER]: 'Vendedor',
  [PaymentMethod.MP_ONLINE_CHECKOUT]: 'Mercado Pago Online',
  [PaymentMethod.UALA_CHECKOUT_ONLINE]: 'Ualá Online',
  [PaymentMethod.PAYWAY_CHECKOUT_ONLINE]: 'PayWay Online',
  [PaymentMethod.NAVE_CHECKOUT_ONLINE]: 'Nave (Naranja X) Online',
  [PaymentMethod.NAVE_LINK_CHECKOUT_ONLINE]: 'Nave Link (Naranja X) Online',
  [PaymentMethod.OTHER]: 'Otro',
};

// Get payment method enum from label
export function getPaymentMethodFromLabel(label: string): PaymentMethod | undefined {
  return Object.entries(PAYMENT_METHOD_LABELS).find(
    ([, value]) => value === label,
  )?.[0] as PaymentMethod | undefined;
}

export interface PaymentAmounts {
  gross_tickets_amount: number;
  discounts_amount: number;
  subtotal: number;
  paid_amount: number;
  service_charge_amount: number;
  seller_comission_amount: number;
  avantti_comission_amount: number;
  net_producer_amount: number;
  payment_method_discount_amount: number;
  referral_comission_amount: number;
  gross_received_amount: number;
  items_count: number;
  audience_discount_amount: number;
  order_referral_comission_amount: number;
  referral_refunded_amount: number | null;
  avantti_amount: number;
  wires_tax_withheld_amount: number;
  other_tax_withheld_amount: number;
  bag_balance: number;
  online_comission_amount: number;
  absorbed_service_charge_amount: number;
}

export interface GatewaySpecificAmounts {
  gateway_amount: number;
  gateway_rate: number;
}

export interface PaymentDTO extends Timestamps, PaymentAmounts, GatewaySpecificAmounts {
  id: string,
  order_id: string,
  description: string;
  remote_id: string | null;
  currency: string;
  status: PaymentStatus;
  reference_number: string | null;
  order_number: string | null;
  provider: string;
  approved_at: Date | null;
  checkout_link: string;
  received_by: PaymentRecipient | null,
  type: PaymentType;
  mark_paid_by: string | null;
  event_id: string;
  details: string;
  cashier_id: string | null;
  payment_method: PaymentMethod | null;
  pending_amount: number | null;
  mark_paid_by_user?: UserDTO | null;
  order?: OrderDTO;
}

export interface AvanttiReport {
  avantti_amount: number;
  gateway_amount: number;
  processed_online_amount: number;
  processed_manual_amount: number;
  processed_payments: number;
  processed_items_count: number;
  processed_split_amount: number;
  processed_received_amount_online: number;
}
